import React from "react";

const Stat_Students_T_Distrib = () => {
  return (
    <div>
      <h1>Stat Students T-Distrib.</h1>
    </div>
  );
};

export default Stat_Students_T_Distrib;
